import React from "react"

const TrailerVideo = ({
    content,
    trailerRef,
    videoSource
}) => {

    const trailerMarkup = `
  <video
      id='trailer-video-${content?.id}'
      height='100%'
      width='100%'
      style="background-color: black"
      autoPlay
      muted
      loop
      >
  <source src=${videoSource} />
  </video>
`;


React.useEffect(()=>{
    if(trailerRef.current){
        trailerRef.current.firstElementChild.load();
    }
},[trailerRef])


    return (<div className='trailerOverview_trailerVideo'>
        {!!videoSource && <div className='trailerOverview_playerContainer'
            ref={el => { trailerRef.current = el; }}
            dangerouslySetInnerHTML={{ __html: trailerMarkup }}
        />}
    </div>)
}

export default TrailerVideo;